enum MmcNotificationAction {
  ACTIVITY_ASSIGNED = "activity assigned",
  ACTIVITY_LOGGED = "activity logged",
  ACTIVITY_STARTING = "activity starting",
  ACTIVITY_TIME_CHANGED = "activity time changed",
  COMPANY_GROUP_SHARED = "company group shared",
  COMPANY_ROUTE_SHARED = "company route shared",
  DEAL_GROUP_SHARED = "deal group shared",
  DEALS_MARKED_LOST = "deals marked lost",
  DEALS_MARKED_WON = "deals marked won",
  DEALS_ROTTING = "deals rotting",
  DEALS_STAGE_CHANGED = "deals stage changed",
  EMAIL_TEMPLATE_SHARED = "email template shared",
  FEATURE_REQUESTED = "feature requested",
  FOLDER_SHARED = "folder shared",
  GUIDE_ASSIGNED = "guide assigned",
  GUIDE_REMINDER = "guide reminder",
  INCOMPLETE_ACTIVITY = "incomplete activity",
  MARK_ACTIVITY_AS_DONE = "mark activity as done",
  MENTION = "mention",
  NOTE_ADDED = "note added",
  ACTIVITY_NOTE_ADDED = "record updated,note added",
  ACTIVITY_NOTE_UPDATED = "record updated,note updated",
  OUT_OF_CADENCE = "out of cadence",
  OVERDUE_ACTIVITIES = "overdue activities",
  OWNED_DEALS_CLOSING = "owned deals closing",
  OWNERSHIP_CHANGED = "ownership changed",
  PEOPLE_GROUP_SHARED = "people group shared",
  PEOPLE_ROUTE_SHARED = "people route shared",
  RESOURCE_SHARED = "resource shared",
  SAVED_FILTER_SHARED = "saved filter shared",
  SHARED_DEALS_CLOSING = "shared deals closing",
  BOUNCED_EMAIL = "bounced email",
  AUTO_TRACKED_TRIPS = "auto tracked trips",
  UNCLASSIFIED_TRIPS = "unclassified auto tracked trips",
  TRIP_FLAGGED = "trip flagged",
  UNIFIED_ROUTE_SHARED = "unified route shared",
  COACHING_NOTE_CREATED = "coaching note created",
  COACHING_NOTE_REPLIED = "coaching note replied",
  COACHING_TASK_CREATED = "coaching task created",
  COACHING_TASK_ASSIGNED = "coaching task assigned",
  COACHING_TASK_COMPLETED = "coaching task completed",
  COACHING_TASK_OVERDUE = "coaching task overdue",
  COACHING_TASK_MENTIONED = "coaching task mentioned",
}

export default MmcNotificationAction;
